// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N2CO","clinicsSelect":"styles_clinicsSelect__1UnkD"};